import script from './component-lib.esm87.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('SvgIcon', _vm._g(_vm._b({
    attrs: {
      "viewBox": "0 0 32 32"
    }
  }, 'SvgIcon', Object.assign({}, _vm.$props, {
    title: _vm.$props.title || 'wordpress'
  }, _vm.$attrs), false), _vm.$listeners), [_c('path', {
    attrs: {
      "d": "M4 16c0 4.626 2.76 8.624 6.763 10.518l-5.724-15.274c-0.666 1.453-1.039 3.062-1.039 4.756zM24.101 15.41c0-1.445-0.533-2.445-0.989-3.223-0.608-0.963-1.179-1.778-1.179-2.741 0-1.074 0.836-2.074 2.015-2.074 0.053 0 0.104 0.006 0.155 0.009-2.135-1.905-4.979-3.069-8.103-3.069-4.192 0-7.881 2.095-10.026 5.268 0.282 0.009 0.547 0.014 0.772 0.014 1.255 0 3.198-0.149 3.198-0.149 0.647-0.037 0.723 0.889 0.077 0.963 0 0-0.65 0.074-1.373 0.111l4.37 12.66 2.626-7.671-1.869-4.989c-0.646-0.037-1.259-0.111-1.259-0.111-0.647-0.037-0.571-1 0.076-0.963 0 0 1.981 0.149 3.16 0.149 1.255 0 3.198-0.149 3.198-0.149 0.647-0.037 0.723 0.889 0.076 0.963 0 0-0.651 0.074-1.373 0.111l4.337 12.563 1.197-3.895c0.518-1.617 0.913-2.778 0.913-3.778zM16.211 17.022l-3.601 10.189c1.075 0.308 2.212 0.476 3.39 0.476 1.397 0 2.738-0.235 3.985-0.663-0.032-0.050-0.062-0.103-0.086-0.161l-3.688-9.842zM26.53 10.393c0.052 0.372 0.081 0.771 0.081 1.202 0 1.185-0.228 2.519-0.913 4.186l-3.665 10.321c3.568-2.026 5.967-5.79 5.967-10.102 0-2.032-0.533-3.943-1.47-5.607zM16 0c-8.837 0-16 7.163-16 16s7.163 16 16 16 16-7.163 16-16-7.163-16-16-16zM16 30c-7.732 0-14-6.268-14-14s6.268-14 14-14 14 6.268 14 14-6.268 14-14 14z"
    }
  })]);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = undefined;
/* scoped */
const __vue_scope_id__ = undefined;
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);
var __vue_component__$1 = __vue_component__;
export { __vue_component__$1 as default };